import { defineMessages } from "react-intl";

export const messages = defineMessages({
  addShippingAddressInfo: {
    id: "BjxQ3u",
    defaultMessage: "add shipping address first",
    description: "add shipping address first label",
  },
  subtotal: {
    id: "xUvWaP",
    defaultMessage: "Subtotal",
    description: "subtotal price",
  },
  addDiscount: {
    id: "Myx1Qp",
    defaultMessage: "Add Discount",
    description: "add discount button",
  },
  discount: {
    id: "+8v1ny",
    defaultMessage: "Discount",
    description: "discount button",
  },
  addShippingCarrier: {
    id: "Jb1/3V",
    defaultMessage: "Add shipping carrier",
    description: "add shipping carrier button",
  },
  noShippingCarriers: {
    id: "M9LXb5",
    defaultMessage: "No applicable shipping carriers",
    description: "no shipping carriers title",
  },
  total: {
    id: "S/yAtJ",
    defaultMessage: "Total",
    description: "total price",
  },
  taxes: {
    id: "mQtoRO",
    defaultMessage: "Taxes (VAT included)",
    description: "taxes title",
  },
});
